// Port of api/fuel/app/classes/filter/search/games/filters/query/play/plays/group.php
import F from 'offline/filter/constants'
export default {
	name: 'play.plays.group',
	priority: 51,
	_package_require: [F.PACKAGE_PLAY],
	require: function(config, filter) { return config.resultType === F.RESULT_GAME },
	run: function(config, filter, data, query) {
		query.concat('p.play_id', 'p')
	}
}
